import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from 'components/Form'
import { parsePhoneNumber } from '../../utils/phone'
// import { parsePhoneNumber, isValidNumber } from '../../utils/phone'
import { setCaretPosition } from '../Form/utils'

const MobileNumber = ({ onChange, value, ...props }) => {
  const defaultValue = '+32 4'
  const [currrentCaretPosition, setCurrentCaretPosition] = React.useState(5)
  const inputRef = React.useRef()

  React.useEffect(
    () => {
      let caretPosition = 0

      if (value) {
        if (currrentCaretPosition === value.length) {
          caretPosition = parsePhoneNumber(value).length
        } else {
          caretPosition = currrentCaretPosition
        }
      } else {
        caretPosition = defaultValue.length
      }

      setCaretPosition(inputRef.current, caretPosition)
    },
    [value],
  )

  const handleChange = event => {
    // const newValue = parsePhoneNumber(value)
    setCurrentCaretPosition(inputRef.current.selectionStart)

    onChange(event)
  }

  return (
    <TextField
      {...props}
      type="tel"
      value={value === defaultValue || !value ? defaultValue : parsePhoneNumber(value)}
      onChange={handleChange}
      innerRef={inputRef}
    />
  )
}

MobileNumber.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default MobileNumber



// WEBPACK FOOTER //
// ./src/components/MobileNumber/index.js